import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { DragHandleIcon } from './styled';

const DragHandle = SortableHandle((props: any) => <DragHandleIcon {...props} />);

export default DragHandle;
